module.exports = __webpack_public_path__ + "static/media/newCertificate1.cbf94859.png";